function inlineFilterItems(instance) {
  const items = [
    {
      id: 'all',
      label: instance.$t('delivery.status.all'),
    },
    {
      id: 'DRAFT',
      label: instance.$t('delivery.status.draft'),
    },
    {
      id: 'CONFIRMED',
      label: instance.$t('delivery.status.confirmed'), 
    },
    {
      id: "RESCHEDULED",
      label: instance.$t('delivery.status.rescheduled'),
    },
    {
      id: 'SCHEDULED',
      label: instance.$t('delivery.status.scheduled'),
    },
    {
      id: 'STARTED',
      label: instance.$t('delivery.status.started'),
    },
    {
      id: 'PICKED',
      label: instance.$t('delivery.status.picked'),
    },
    {
      id: 'IN_TRANSIT',
      label: instance.$t('delivery.status.inTransit'),
      isShow: true,
    },
    {
      id: 'DELIVERED',
      label: instance.$t('delivery.status.delivered'),
    },
    {
      id: 'CANCELED',
      label: instance.$t('delivery.status.canceled'),
    },
  ]

  return items.filter(item => item.isShow !== false)
}

export default inlineFilterItems
